import React from 'react';
import Mywork from '../components/Mywork';
import Myproject from '../components/Myproject';
import Mydetails from '../components/MyDetails';
const Work: React.FC = () => {
  return (
    <>
      <Mywork />
      <Myproject />
      <Mydetails />
    </>
  );
};

export default Work;